import bluepay from './pay/bluepay'
import codapay from './pay/codapay'
import gash from './pay/gash'
import mol from './pay/mol'
import paypal from './pay/paypal'
import infobip from './pay/infobip'
import funapp from './pay/funapp'
// import anpay from './pay/anpay'
// import fptgate from './pay/fptgate'
import jQuery from 'jquery'

const channelName = {
    10001: 'Fortumo',
    10002: 'Fortumo',
    10003: 'Mol',
    10004: 'Mol',
    10005: 'BluePay',
    10006: 'BluePay',
    10007: 'Gash',
    10008: '1Pay',
    10009: 'VNPT',
    10010: 'Infobip',
    10022: 'Funapp',
    // 10010: 'Mimopay',
    // 10011: 'Mimopay',
    10012: 'Codapay',
    10013: 'Upay',
    100131: 'Anpay',
    100132: 'FPT Gate',
    10014: 'MyCard',
    10015: 'MyCard',
    10016: 'PayPal',
    10017: 'UniPin',
    10018: 'UniPin',
    10019: 'Paymentwall',
    10020: '支付宝'
};
let myCardResult;
let test = function () {
    jQuery.ajax({
        type: 'get',
        url: '/api/recharge/mycard/payMethod',
        async: false,
        success: function (result) {
            myCardResult = result.message;
        }
    });
};
test();
const channelDetail = [
    {
        name: 'Anpay',
        key: 'anpay',
        methods: {}
    },
    {
        name: 'FPT Gate',
        key: 'fptgate',
        methods: {}
    },
    {
        name: 'BluePay',
        key: 'bluepay',
        methods: bluepay
    },
    {
        name: 'Infobip',
        key: 'infobip',
        methods: infobip
    },
    {
        name: 'Fortumo',
        key: 'fortumo',
        methods: {}
    },
    {
        name: 'Mycard',
        key: 'mycard',
        methods: myCardResult
    },
    {
        name: 'Funapp',
        key: 'funapp',
        methods: funapp
    },
    {
        name: 'Codapay',
        key: 'codapay',
        methods: codapay
    },
    {
        name: 'Gash',
        key: 'gash',
        methods: gash
    },
    {
        name: 'Mol',
        key: 'mol',
        methods: mol
    },
    {
        name: 'Local Payment',
        key: 'paymentwall',
        methods: {}
    },
    {
        name: 'PayPal',
        key: 'paypal',
        methods: paypal
    }
];

export {channelDetail, channelName};



// WEBPACK FOOTER //
// ./src/config/channels.js